/*
DoubleIncDescription.js
双增公式的简介，用于Collapse折叠面板
 */
import {Image} from "antd";
import {BlockMath, InlineMath} from "react-katex";

import DoubleIncImg from '../Images/DoubleIncImg.png'

export const DoubleIncDescription = [
    {
        key: '1',
        label: <h3>双增公式的拓扑定义</h3>,
        children: (
            <div>
                <p>三个互相存在热量传递关系的封闭球面，无论是否有内热源，封闭球面的环境温度如何变化，只要知道其中的两个球面的热力学温度，就可以计算出第三个球面的热力学温度，同实际采集的热力学温度基本一致。数学公式如下：</p>
                <BlockMath math={`\\frac{T_{2}^{2}-T_{3}^{2}}{T_{1}^{2}-T_{3}^{2}}=K \\frac{T_{2}^{2}}{T_{1}^{2}}`}/>
                <p>其中<InlineMath math={`T_{1}`}/>, <InlineMath math={`T_{2}`}/>, <InlineMath math={`T_{3}`}/>分别代表三个球面的热力学温度（温度+273.15°C），三个球面的表面积分别为<InlineMath
                    math={`A_{1}`}/>，<InlineMath math={`A_{2}`}/>，<InlineMath math={`A_{3}`}/>，其中
                </p>
                <Image src={DoubleIncImg}/>
                <BlockMath math={`K=\\frac{A_{1}}{A_{2}}`}/>
                <p>这个数学公式我们叫“双增公式”，就是保持热力球体的结构不变，当<InlineMath math={`T_{1}`}/>增加的时候，要维持<InlineMath
                    math={`T_{3}`}/>不变，一方面<InlineMath math={`T_{2}`}/>增加，另外一个方面<InlineMath
                    math={`(T_{1}-T_{2})`}/>的差也必然增加</p>
            </div>
        ),
    },
    {
        key: '2',
        label: <h3>双增公式的供热系统定义</h3>,
        children: (
            <div>
                <p>舒效比理论中，对供热系统进行拓扑等效的处理，供热系统可以拓扑为一层一层的热力球的结构，然后等效处理，就是最后热源对环境的影响结果是等效的，目的是可以通过热力球表面的温度值，计算获得一个反应当下系统整体保温情况的K值。数学公式如下：</p>
                <BlockMath math={`\\frac{T_{h}^{2}-T_{s}^{2}}{T_{g}^{2}-T_{s}^{2}}=K \\frac{T_{h}^{2}}{T_{g}^{2}}`}/>
                <p>其中<InlineMath math={`T_{g}`}/>, <InlineMath math={`T_{h}`}/>分别代表供热系统的供水温度（温度+273.15°C），回水温度（温度+273.15°C）；<InlineMath
                    math={`T_{s}`}/> 代表春天(Spring)室内外温度都是20°C（20°C+273.15°C），不需要采暖，也不需要制冷的一个标准温度值，也就是<InlineMath
                    math={`K`}/>值等于1对应的温度值。计算公式中使用的温度，一定都要使用热力学温度。热力学温度的平方代表物体的火积势能（物体对外散热的能力）。
                </p>
                <p>供热系统也符合“双增公式”的原理，就是保持供热系统的几何结构不变（包含流量不变），当<InlineMath
                    math={`T_{g}`}/>增加的时候，要维持室内舒适度不变，一方面<InlineMath
                    math={`T_{g}`}/>增加，另外一个方面<InlineMath math={`(T_{g}-T_{h})`}/>的差也必然增加。当室外温度降低，需要增加热负荷的时候，供水温度增加，回水温度必然增加，同时供水温度与回水温度的差也必然增加。
                </p>
            </div>
        ),
    }
];